import { Container, Text } from 'pixi.js';
import gsap from 'gsap';
import { config } from '../config/config';

import * as PIXI from 'pixi.js';
import PixiPlugin from 'gsap/PixiPlugin';
PixiPlugin.registerPIXI(PIXI);
gsap.registerPlugin(PixiPlugin);

const TEXT_COLOR = 0xffffff;

class Counter extends Container {
  private counterText: Text;
  private timeoutId?: number;
  private blinkTween?: any;
  constructor() {
    super();

    this.counterText = new Text('', {
      fontFamily: 'Grandstander',
      fontSize: '60px', //todo font size
      fill: TEXT_COLOR,
      fontWeight: 'bold',
      dropShadow: true,
      dropShadowAlpha: 0.2,
    });
    this.counterText.x = -this.counterText.width / 2;
    this.counterText.y = 25;
    this.counterText.anchor.set(0, 0.5);

    this.addChild(this.counterText);

    this.x = config.SIZES.MAX_WIDTH / 2;
    this.y = 35;
  }

  setText(count: number, total: number) {
    this.counterText.text = count + '/' + total;
    this.counterText.x = -this.counterText.width / 2;
  }

  public showCounter = (show: boolean) => {
    gsap.to(this.counterText, {
      duration: 1,
      ease: !show ? 'back.out' : 'back.in',
      alpha: !show ? 0 : 1,
    });
  };

  blink() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = undefined;
    }
    this.showCounter(true);
    if (this.blinkTween) {
      this.blinkTween.restart();
    } else {
      this.blinkTween = gsap.to(this.counterText, {
        pixi: {
          tint: 0xb022f3,
        },
        duration: 0.2,
        yoyo: true,
        repeat: 5,
        repeatDelay: 0.1,
      });
    }
    this.timeoutId = setTimeout(() => {
      this.showCounter(false);
    }, 5000);
  }
}

export default Counter;
